<template>
  <div>
        <el-main>
          <router-view :key="$route.path" />
        </el-main>
      </div>
</template>
<script>
export default {
  data () {
    return {
      activeIndex: this.$route.path,
    }
  },
  created(){

  }
}
</script>
<style lang='less' scoped>
.containerBox {
  padding: 14px;
  background-color: rgba(249, 249, 249, 1);
}
.container{
      background-color: #fff;
}
.el-main {
  background-color: rgba(249, 249, 249, 1);
  padding: 0;
}
.container {
  border: 1px solid rgb(228, 228, 228);
  border-top: 7px solid rgba(52, 152, 219, 1);
}
.el-breadcrumb {
  height: 50px;
  font-size: 16px;
  line-height: 50px;
  color: #999;
  background-color: rgba(236, 240, 245, 1);
  margin-left: 20px;
}
.header {
  font-weight: 700;
  font-style: normal;
  color: #5e5e5e;
  height: 50px;
  line-height: 50px;
  margin-left: 10px;
}
.ax_default {
  font-family: "ArialMT", "Arial";
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  border-bottom: 1px solid#333333;
  text-align: center;
  line-height: normal;
}
.line {
  height: 1px;
}
</style>